import repute from "./assets/repute.png";
import metabnb from "./assets/Metabnb.png";
import plaza from "./assets/pinaccl.png";
import Movie from "./assets/Movie.png";
import furniture from "./assets/furniture.png";
import Music from "./assets/Music.png";
import tayo from "./assets/tayorp.png";

export const projects = [
  {
    img: repute,
    name: "Repute",
    description: "Reputation Manager",
    webLink: "https://repute.legal/",
  },
  {
    img: metabnb,
    name: "Metabnb",
    description: "Airbnb for Metaverse",
    webLink: "https://hng-metabnb-e336733tk-tayor99.vercel.app/",
  },
  {
    img: plaza,
    name: "Plazza",
    description: "Online shop",
    webLink: "https://plaza-sigma.vercel.app/",
  },
  {
    img: Movie,
    name: "Movie App",
    description: "Application for searching for movie",
    webLink: "https://plaza-sigma.vercel.app/",
  },
  {
    img: furniture,
    name: "Comfy Sloth",
    description: "Online Furniture Shop",
    webLink: "https://e-commerce-cdrecw1ru-tayor99.vercel.app/",
  },
  {
    img: Music,
    name: "Music App",
    description: "Music playing app",
    webLink: "https://musicapp-five.vercel.app/",
  },
  {
    img: tayo,
    name: "Portfolio",
    description: "Previous Portfolio",
    webLink: "https://portfolio-eight-gamma-72.vercel.app/",
  },
];
